/**
 * @title 处理行程提交数据
 */
export const formatItineraryList = (list = []) => {
  return list
    .map(f => {
      const spots = f?.spots.filter(t => t).map(s => ({
        id: s?.id + ''
      }))

      return {
        describe: f?.describe || undefined,
        spots: spots?.length ? spots : undefined
      }
    })
    .filter(f => f?.describe || f.spots?.length)
}

/**
 * @title 处理行程返回数据
 */

export const formatGetItineraryList = (list = []) => {
  return list.map(f => ({
    describe: f?.describe,
    spots:
      f?.spots?.map(t => ({
        id: t?.id + '',
        name: t?.name,
        cover: t?.latest_case?.cover_path ?? t?.default_cover_path
      })) ?? []
  }))
}
